import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "uv-tile-ctas" }
const _hoisted_2 = ["onClick"]

import { computed } from 'vue'; 
	
	import { useStore } from 'vuex';
	import { ECtas } from '@/enums';
	import { IVehicle } from '@/types.d'

	
export default /*#__PURE__*/_defineComponent({
  props: {
    vehicle: null
  },
  setup(__props: any) {

const props = __props as {
		vehicle: IVehicle
	}

	

	const store = useStore();
	const ctas = computed(() => props.vehicle.TileButtons || store.state.ctas);

	const getCtaClass = (cta: string, index: number): string => {
		return cta == ECtas.equote ? 'button-brand' : index % 2 == 0 ? 'button-solid' : 'button-outline';
	};
	const handleCtaClick = (cta: string): void => {
		if (cta == ECtas.requestAVideoButton && (window as any).uvCtasRequestAVideoUseUrl){
			(window as any).location = props.vehicle.DetailsPageUrl;
		}
		else if (cta == ECtas.equote) {
			(window as any).location = props.vehicle.DetailsPageUrl;
		}
		else if (cta != ECtas.reserveButton) {
			store.commit('setEnquiryModal', {
				isVisible: true, 
				type: cta, 
				vehicle: props.vehicle
			});
		}
		else {
			(window as any).location = `/checkout/${props.vehicle.StockNum}`;
		}
	}
	const getCtaText = (cta: string): string => {
		let t = ''
		switch (cta){
			case ECtas.equote: {
				t = 'Get Your Repayments';
				break;
			}
			case ECtas.requestAVideoButton: {
				t = 'Learn More';
				break;
			}
			case ECtas.testDriveButton: {
				t = 'Test Drive';
				break;
			}
			case ECtas.enquireButton: {
				t = 'Enquire';
				break;
			}
			case ECtas.reserveButton: {
				t = `${(window as any).uvStoreDeposit} to hold`;
				break;
			}
		}
		return t;
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ctas), (cta, index) => {
      return (_openBlock(), _createElementBlock("button", {
        type: "button",
        key: index,
        class: _normalizeClass(getCtaClass(cta, index)),
        onClick: ($event: any) => (handleCtaClick(cta))
      }, _toDisplayString(getCtaText(cta)), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})